module.exports = __webpack_public_path__ + "assets/modal-topbg-d9d7eeaa.png";